import styled from "@emotion/styled";

const Ul = styled.ul`
  ${({theme}) => theme.text.p2}
  padding-inline-start: 20px;
`;

export default Ul;
